import { Select, Button, Input } from '@panwds/react-ui';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { v4 } from 'uuid';

const SelectPage = (props) => {
    var _a, _b;
    const intl = useIntl();
    const translations = {
        pageLabel: intl.formatMessage({
            defaultMessage: 'Page',
            id: 'Aj5rGO',
            description: 'Label for Page selector dropdown'
        })
    };
    const { disabled = false, onSelectPage, menuStyle, pageIndex, pageOptions, dataTestId, pageType = 'select', pageLabel = translations.pageLabel } = props;
    const labelId = useMemo(() => `table-page-${v4()}-label`, []);
    const buttonId = useMemo(() => `table-page-${v4()}-button`, []);
    const labelInputId = useMemo(() => `table-page-${v4()}-input-label`, []);
    const inputId = useMemo(() => `table-page-${v4()}-input`, []);
    const memoizedPageOptions = useMemo(() => pageOptions.map((i) => ({ value: i + 1 })), [pageOptions]);
    return (React.createElement(React.Fragment, null,
        pageType === 'select' && (React.createElement(React.Fragment, null,
            React.createElement("label", { id: labelId, htmlFor: buttonId, className: "tw-flex tw-space-x-4 tw-leading-loose tw-text-xs" }, pageLabel),
            React.createElement(Select, { menuStyle: menuStyle, labelId: labelId, toggleButtonId: buttonId, "data-testid": "select-page", button: React.createElement(Button, { dataTestId: `${dataTestId}-select-page-button`, isMenu: true, appearance: "tertiary" }, (_a = memoizedPageOptions[pageIndex]) === null || _a === void 0 ? void 0 : _a.value), defaultPlacement: "top-start", disabled: disabled, selectedItem: memoizedPageOptions[pageIndex] || null, items: memoizedPageOptions, onChange: ({ selectedItem }) => {
                    onSelectPage((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) - 1);
                } }))),
        pageType === 'input' && (React.createElement(React.Fragment, null,
            React.createElement("label", { id: labelInputId, htmlFor: inputId, className: "tw-flex tw-space-x-4 tw-leading-loose tw-text-xs" }, pageLabel),
            React.createElement(Input, { addClassName: "tw-w-10", "aria-label": "Go", "data-testid": "go-to-page", value: (_b = memoizedPageOptions[pageIndex]) === null || _b === void 0 ? void 0 : _b.value.toString(), onChange: (e) => {
                    onSelectPage(Number.parseInt(e.currentTarget.value, 10) - 1);
                } })))));
};

export { SelectPage };
//# sourceMappingURL=SelectPage.esm.js.map
